import React from "react";
import ReactMarkdown from "react-markdown";

/**
 * Renders admin-authored Markdown (FAQ answers, etc.). react-markdown does not
 * render raw HTML by default, so untrusted markup is safe. Links open in a new
 * tab.
 */
const MarkdownView = ({ children }) => {
  if (!children) return null;
  return (
    <div className="raise-markdown">
      <ReactMarkdown
        components={{
          a: ({ node, ...props }) => (
            <a {...props} target="_blank" rel="noopener noreferrer" />
          ),
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownView;
